import type { UserGroup } from '@efdigital/ll-addon-data';
import { DataTypeSystem } from '@efdigital/ll-addon-data/data-types';
import { setAsyncBelongsTo } from '@efdigital/ll-admin-v2/data/async-setter.ts';
import {
  dummyUserAdmin,
  dummyUserParticipant,
} from '@efdigital/ll-admin-v2/utils/user-groups.ts';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { ProgramsProgramCohortModel } from '../cohort.ts';

export type ProgramsProgramCohortParticipantsModel =
  ProgramsProgramCohortModel & {
    group: UserGroup;
    admingroup: UserGroup;
  };

export default class ProgramsProgramCohortParticipantsRoute extends Route<ProgramsProgramCohortModel> {
  @service declare store: Store;

  async model() {
    const parentModel = this.modelFor(
      'programs.program.cohort'
    ) as ProgramsProgramCohortModel;
    const cohort = parentModel.cohort;

    let group = await cohort.group;
    if (!group) {
      group = this.store.createRecord<UserGroup>(DataTypeSystem.UserGroup, {
        title: `${cohort.slug}-participants`,
        userIds: [dummyUserParticipant],
      });
      setAsyncBelongsTo(cohort, 'group', group);
    }

    let admingroup = await cohort.admingroup;
    if (!admingroup) {
      admingroup = this.store.createRecord<UserGroup>(
        DataTypeSystem.UserGroup,
        {
          title: `${cohort.slug}-admins`,
          userIds: [dummyUserAdmin],
        }
      );
      setAsyncBelongsTo(cohort, 'admingroup', admingroup);
    }
    return {
      ...parentModel,
      group,
      admingroup,
    };
  }
}
